<script setup lang="ts">
import { ref, defineProps } from 'vue';
import SvgIcon from '@/presentation/components/common/svg-icon/SvgIcon.vue';
import '@patsnap-ui/icon/assets/solid/DoubleArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/DoubleArrowLeft.svg';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
withDefaults(defineProps<{ title: string; floatBtnLabel?: string; collapseLabel?: string }>(), {
    floatBtnLabel: '',
    collapseLabel: '',
});
const isCollapse = ref(false);

function toggleCollapse() {
    isCollapse.value = !isCollapse.value;
}
</script>

<template>
    <div class="collapse-box h-screen">
        <div
            v-if="isCollapse"
            class="pt-4"
        >
            <button
                class="collapse-boc-header th-btn h-8 flex-nowrap !rounded-r-none pl-2"
                @click="toggleCollapse"
            >
                <SvgIcon
                    class="th-btn-icon h-6 w-6 !fill-white"
                    icon="SolidDoubleArrowLeft"
                />
                <span class="whitespace-nowrap">
                    {{ floatBtnLabel || t('aiDisclosureGlobal.globalBtn.collapse') }}
                </span>
            </button>
        </div>

        <div v-else class="h-full w-[400px] border-l border-gray-40 p-4">
            <div
                class="collapse-boc-header flex items-center justify-between"
            >
                <span class="text-[18px] font-semibold">
                    {{ title }}
                </span>
                <button
                    class="th-btn th-btn-plain flex cursor-pointer items-center"
                    @click="toggleCollapse"
                >
                    <SvgIcon
                        class="th-btn-icon h-6 w-6 !text-grey-450"
                        icon="SolidDoubleArrowRight"
                    />
                    <span>
                        {{ collapseLabel || t('aiDisclosureGlobal.globalBtn.collapse') }}
                    </span>
                </button>
            </div>

            <slot />
        </div>
    </div>
</template>
